<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Clockify" class="d-icon d-icon--clockify" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.05 2.039a10.025 10.025 0 0 0-7.112 4.043c-2.584 3.493-2.584 8.34 0 11.833 2.078 2.81 5.491 4.364 8.88 4.043 1.265-.12 2.601-.488 3.598-.993l.385-.194-1.095-1.095-1.095-1.095-.702.213c-.625.19-.83.214-1.879.218-.912.003-1.3-.029-1.725-.142-1.317-.352-2.351-.946-3.295-1.892-.743-.745-1.197-1.423-1.557-2.326-.413-1.033-.482-1.427-.476-2.732.004-1.086.027-1.29.215-1.906.751-2.467 2.589-4.267 5.034-4.93.5-.137.85-.172 1.726-.174 1.072-.002 1.54.069 2.375.362l.257.09 1.057-1.054c.582-.58 1.057-1.078 1.057-1.105 0-.073-1.03-.52-1.715-.744-1.14-.372-2.722-.542-3.933-.42Z" fill="#03A9F4"/><path fill-rule="evenodd" clip-rule="evenodd" d="m16.987 6.593-2.274 2.275.646.647.647.647L18.3 7.868l2.293-2.294-.624-.628c-.344-.346-.644-.629-.667-.629-.023 0-1.065 1.024-2.315 2.276Zm-4.698 3.802c-.37.132-.814.54-.96.883-.171.397-.137 1.105.07 1.47a1.605 1.605 0 0 0 2.468.408c.981-.861.604-2.474-.651-2.79-.429-.108-.551-.104-.927.03Zm3.09 4.004-.666.669 2.294 2.293 2.294 2.294.667-.667.667-.667-2.296-2.295-2.296-2.295-.665.668Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconClockify',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
